// Internal admin client. Not for the browser bundle.
export const API_SECRET = process.env.NEXT_PUBLIC_API_SECRET!;

export function adminStats() {
  return fetch('https://api.prelaunch-control.invalid/v1/admin/stats', {
    headers: { Authorization: `Bearer ${API_SECRET}` },
  });
}
